import React from 'react';
import { Box, Typography, FormControl, RadioGroup, FormControlLabel } from '@mui/material';
import { t } from 'i18next';
import BlueRadio from '../../../../../components/blueradio/BlueRadio';
import { theme } from '../../../../../theme/maintheme';

type MFAProps = {
  handleChange: any;
  MFAInfo: { typeMFA: string; enableMFA: boolean};
};

const MFA = (props: MFAProps) => {
  const { handleChange, MFAInfo } = props;
  
  return (
    <Box
      sx={{
        border: "1px solid #000",
        borderRadius: "12px",
        padding: theme.spacing(3),
        marginTop: theme.spacing(3)
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2" fontWeight={"bold"} sx={{ mr: 1 }}>
          {t("MFAAuthentication")}
        </Typography>
      </Box>
      <FormControl component="fieldset" sx={{ my: 2 }}>
        <RadioGroup
          aria-labelledby="radio-role"
          name="MFA"
          row
          //@ts-nocheck
          value={MFAInfo.enableMFA}
          onChange={handleChange}
        >
        <FormControlLabel
          value={false}
          label={t("OFF")}
          control={<BlueRadio onChange={handleChange} />}
        />
        <FormControlLabel
          value={true}
          label={t("ON")}
          control={<BlueRadio onChange={handleChange} />}
        />
      </RadioGroup>
    </FormControl>
   </Box>
  )
}

export default MFA